var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "messenger",
    d: "M8,0A8,8,0,0,0,1.061,11.982L.03,15.183a.625.625,0,0,0,.786.786l3.2-1.031A8,8,0,1,0,8,0ZM8,14.75a6.73,6.73,0,0,1-3.573-1.023.625.625,0,0,0-.523-.065l-2.311.744L2.338,12.1a.625.625,0,0,0-.065-.523A6.75,6.75,0,1,1,8,14.75ZM8.781,8A.781.781,0,1,1,8,7.219.781.781,0,0,1,8.781,8Zm3.125,0a.781.781,0,1,1-.781-.781A.781.781,0,0,1,11.906,8ZM5.656,8a.781.781,0,1,1-.781-.781A.781.781,0,0,1,5.656,8Zm0,0",
    fill: "#fff",
    opacity: 0.301
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.979ece3d70ae4beb77a32c2633798cd4.svg";
export { ForwardRef as ReactComponent };